import React from 'react';
import { useHistory } from 'react-router-dom';
import {useGatedAccess} from "@carvana/core-auth";
import { useDualEventTracking } from '../../../../utils/useDualEventTracking';
import {
  LoanDetailsWrapper,
  LoanDetailsLink,
  LoanDetailsLinkBody,
  LoanDetailsTextWrapper,
  LoanDetailsLinkTitle,
  MyCarsArrowForward,
  MyCarsDollarIcon,
  DollarSignWrapper,
} from './LoanDetails.styles';

const LoanDetails = ({ vehicleId }: { vehicleId: any }) => {
  const gate = useGatedAccess();
  const history = useHistory();
  const { trackEvent } = useDualEventTracking();

  const clickLoanDetail = () => {
    trackEvent('loan_details_tap', { vehicleId });
    history.push(`/loan-detail/${vehicleId}`);
  };

  return (
    <LoanDetailsWrapper>
      <LoanDetailsLink onClick={() => gate('MyCars:LoanDetails', clickLoanDetail)}>
        <DollarSignWrapper>
          <MyCarsDollarIcon />
        </DollarSignWrapper>
        <LoanDetailsTextWrapper>
          <LoanDetailsLinkTitle>Loan Details</LoanDetailsLinkTitle>
          <LoanDetailsLinkBody>
            Make a payment to Bridgecrest
          </LoanDetailsLinkBody>
        </LoanDetailsTextWrapper>
        <MyCarsArrowForward />
      </LoanDetailsLink>
    </LoanDetailsWrapper>
  );
};

export default LoanDetails;
